import { css } from '@emotion/css';
import { useTheme } from '@emotion/react';
import { DialogTitle, Typography } from '@material-ui/core';
import React from 'react';  

export const DialogTitleWithColor: React.FC<{
  color: 'red' | 'green' | 'yellow' | 'blue' | 'purple';
}> = ({ color, children }) => {
  const theme = useTheme();
  return (
    <DialogTitle
      classes={{
        root: css({
          background: theme.custom.colors[color].w500,
          color: theme.custom.colors[color].contrastText,
          padding: `${theme.spacing(3)}px ${theme.spacing(4)}px !important`
        })
      }}
    >
      <Typography variant="h4" component="h1">{children}</Typography>
    </DialogTitle>
  );
};
